module.exports = __webpack_public_path__ + "img/tm1.92a8a5dc.jpg";